export const FETCH_ALL_METRICS = "FETCH_ALL_METRICS";
export const FETCH_METRIC = "FETCH_METRIC";
export const CREATE_METRIC = "CREATE_METRIC";
export const UPDATE_METRIC = "UPDATE_METRIC";
export const DELETE_METRIC = "DELETE_METRIC";
